module.exports = __webpack_public_path__ + "img/index10.f00c5611.jpg";